<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';
	import Modal from '$lib/components/Modal/Modal.svelte';
	import Size from '$lib/components/Modal/size';
	import type { Writable } from 'svelte/store';
	import PerformancePage from './PerformancePage.svelte';
	import type { Hub } from '$lib/api/rpc';

	export let hub: Writable<Hub>;
</script>

<Modal type={Size.Large}>
	<Icon clickable icon="analytics" size={'24'} color={$hub.theme.headerIconColor} slot="target" />
	<div class="modal" slot="content"><PerformancePage /></div>
</Modal>

<style>
	.modal {
		margin-inline: var(--gutterSmall);
		padding-inline: var(--gutterSmall);
	}
</style>
